'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// ./~/_call-bind-apply-helpers@1.0.2@call-bind-apply-helpers/functionCall.js
// module id = D55Z
// module chunks = 0